module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Bold.c18403d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Bold.woff2
// module id = MY3C
// module chunks = 0